import { useMutation, useQuery } from 'react-query';
import { request, request_v2 } from '../utils/axios-utils';

const GetMergedGuidelinesForShoot = async (pageNum, pageSize, searchName) => {
    let params = {
        pageNum,
        pageSize,
        searchName,
    };
    if (!searchName) {
        delete params['searchName'];
    }

    const { data } = await request_v2({
        method: 'get',
        url: '/guideline/listInventorySessions',
        params: {
            ...params,
        },
    });
    return data;
};

const CreateMergedGuidelineForShoot = async (links, name, teamLead) => {
    const { data } = await request_v2({
        method: 'post',
        url: '/guideline/createInventorySessions',
        body: {
            links,
            name,
            teamLead,
        },
    });
};

const AddBarcodeToGuideline = async (mergeId, barcode, comment) => {
    const { data } = await request_v2({
        method: 'post',
        url: '/guideline/addBarcodeToGuideline',
        body: {
            mergeId,
            barcode,
            comment,
        },
    });
    return data;
};

const AddLinkToGuideline = async (mergeId, link) => {
    const { data } = await request_v2({
        method: 'post',
        url: '/guideline/addLinkToMerge',
        body: {
            mergeId,
            link,
        },
    });
    return data;
};

const getLinkVerifiedForGuidelineForShoot = async link => {
    const { data } = await request_v2({
        method: 'get',
        url: `/guideline/getMergeLinkInfoByLink?link=${link}`,
    });
    return data;
};

export const useGetMergedGuidelinesForShoot = (pageNum, pageSize, searchText) =>
    useQuery(['MergedLinksForShoot', pageNum, pageSize, searchText], () => GetMergedGuidelinesForShoot(pageNum, pageSize, searchText), {
        refetchOnWindowFocus: true,
        keepPreviousData: false,
        enabled: true,
        cacheTime: 0,
        staleTime: 0,
    });
export const useLinkVerifiedForGuidelineForShoot = link =>
    useQuery(['getLinkVerification', link], () => getLinkVerifiedForGuidelineForShoot(link), {
        refetchOnWindowFocus: false,
        keepPreviousData: true,
        enabled: !!link,
        retry: (failureCount, error) => {
            if (failureCount > 2) {
                return false;
            }
        },
    });
export const useCreateMergedGuidelinesForShoot = () =>
    useMutation({
        mutationFn: async ([links, name, teamLead]) => {
            return await CreateMergedGuidelineForShoot(links, name, teamLead);
        },
    });

const AddGuidelinesToInventorySession = async (sessionId, links) => {
    const { data } = await request_v2({
        method: 'post',
        url: '/guideline/addGuidelinesToInventorySession',
        body: { sessionId, links },
    });
    return data;
};

export const useAddGuidelinesToInventorySession = () =>
    useMutation({
        mutationFn: async ([sessionId, links]) => AddGuidelinesToInventorySession(sessionId, links),
    });

export const useAddBarcodeToGuideline = () =>
    useMutation({
        mutationFn: async ([mergeId, barcode, comment]) => {
            return await AddBarcodeToGuideline(mergeId, barcode, comment);
        },
    });

export const useAddLinkToGuideline = () =>
    useMutation({
        mutationFn: async ([mergeId, link]) => {
            return await AddLinkToGuideline(mergeId, link);
        },
    });
export const DeleteMergeGuidelineForShoot = async sessionId => {
    return await request_v2({
        method: 'delete',
        url: `/guideline/deleteInventorySession`,
        body: { sessionId },
    });
};

export const useDeleteMergeGuidelineForShoot = () =>
    useMutation({
        mutationFn: async ([sessionId]) => {
            return await DeleteMergeGuidelineForShoot(sessionId);
        },
        keepPreviousData: false,
    });
